import React, { useState, useEffect } from "react"
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row,
  Button,
  Form,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { useHistory } from "react-router-dom"
import { Link } from "react-router-dom"
import { toast, ToastContainer } from "react-toastify"
import Dropzone from "react-dropzone"
import axios from "axios"
import { URLS } from "Url"
import Select from "react-select"
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete"

function AddVendors() {
  const [form, setform] = useState([])
  const [selectedFiles, setselectedFiles] = useState([])
  const [selectedFiles1, setselectedFiles1] = useState([])

  const [tags, setTags] = useState([])
  const [inputValue, setInputValue] = useState("")

  const handleInputChange = event => {
    setInputValue(event.target.value)
  }

  const handleKeyDown = event => {
    if (event.key === "Enter" && inputValue.trim()) {
      event.preventDefault()
      if (!tags.includes(inputValue.trim())) {
        setTags([...tags, inputValue.trim()])
        setInputValue("")
      }
    }
  }

  const removeTag = indexToRemove => {
    setTags(tags.filter((_, index) => index !== indexToRemove))
  }

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  var datas = data.token

  const handleSubmit = e => {
    e.preventDefault()
    Adddealer()
  }

  const [selectedOptions, setSelectedOptions] = useState([])

  const history = useHistory()

  const [address, setaddress] = useState("")
  const [state, setState] = useState("")
  const [district, setDistrict] = useState("")
  const [pincode, setPincode] = useState("")
  const [coordinateds, setcoordinateds] = useState({
    lat: "",
    lng: "",
    address: "",
  })

  const handleSelects = async value => {
    setaddress(value)
    try {
      const results = await geocodeByAddress(value)
      const latLng = await getLatLng(results[0])
      setcoordinateds(latLng)

      const addressComponents = results[0].address_components

      const stateComponent = addressComponents.find(component =>
        component.types.includes("administrative_area_level_1")
      )

      const districtComponent = addressComponents.find(component =>
        component.types.includes("administrative_area_level_3")
      )

      const pincodeComponent = addressComponents.find(component =>
        component.types.includes("postal_code")
      )

      setState(stateComponent ? stateComponent.long_name : "")
      setDistrict(districtComponent ? districtComponent.long_name : "")
      setPincode(pincodeComponent ? pincodeComponent.long_name : "")
    } catch (error) {
      console.error("Error:", error)
    }
  }

  const Adddealer = () => {
    var token = datas

    const selectedIds = selectedOptions?.map(option => option.value)

    const dataArray = new FormData()
    dataArray.append("serviceId", form._id)
    dataArray.append("name", form.name)
    dataArray.append("aboutUs", form.aboutUs)
    dataArray.append("subcategoryId", form.subcategoryId)
    dataArray.append("categoryId", form.categoryId)
    dataArray.append("facilities", JSON.stringify(selectedIds))
    dataArray.append("tag", tags)
    dataArray.append("email", form.email)
    dataArray.append("contact", form.contact)
    dataArray.append("website", form.website)
    dataArray.append("dateEstablished", form.dateEstablished)
    dataArray.append("openTime", form.openTime)
    dataArray.append("closeTime", form.closeTime)
    dataArray.append("state", state)
    dataArray.append("city", district)
    dataArray.append("pincode", pincode)
    dataArray.append("address", address)
    dataArray.append("facebook", form.facebook)
    dataArray.append("instagram", form.instagram)
    dataArray.append("google", form.google)
    dataArray.append("twitter", form.twitter)
    dataArray.append("linkedIn", form.linkedIn)
    dataArray.append("youtube", form.youtube)
    dataArray.append("latitude", coordinateds.lat)
    dataArray.append("longitude", coordinateds.lng)

    for (let i = 0; i < selectedFiles.length; i++) {
      dataArray.append("businessLogo", selectedFiles[i])
    }

    for (let i = 0; i < selectedFiles1.length; i++) {
      dataArray.append("serviceImg", selectedFiles1[i])
    }

    axios
      .post(URLS.EditListing, dataArray, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(
        res => {
          if (res.status === 200) {
            toast(res.data.message)
            history.push(
              "/Listing",
              sessionStorage.setItem(
                "tost",
                "Listing has been Updated successfully"
              )
            )
          }
        },
        error => {
          if (error.response && error.response.status === 400) {
            toast(error.response.data.message)
          }
        }
      )
  }

  const handlechange = e => {
    const myform = { ...form }
    myform[e.target.name] = e.target.value
    setform(myform)
  }

  const handleChange = setter => e => {
    setter(e.target.value)
  }

  const handleDrop1 = acceptedFiles => {
    if (acceptedFiles.length > 0) {
      const file = acceptedFiles[0]
      const fileExtension = file.name.split(".").pop().toLowerCase()
      const allowedExtensions = ["jpg", "jpeg", "png", "JPG", "JPEG", "PNG"]

      if (!allowedExtensions.includes(fileExtension)) {
        toast("Invalid file format! Only JPG, JPEG, PNG are allowed.")
        return
      }

      const validatedFile = Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatFileSize1(file.size),
      })

      setselectedFiles([validatedFile])
    }
  }

  const formatFileSize1 = bytes => {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"]
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i]
  }

  const handleDrop2 = acceptedFiles => {
    const allowedExtensions = ["jpg", "jpeg", "png", "JPG", "JPEG", "PNG"]
    const validatedFiles = []

    acceptedFiles.forEach(file => {
      const fileExtension = file.name.split(".").pop().toLowerCase()
      if (allowedExtensions.includes(fileExtension)) {
        const validatedFile = Object.assign(file, {
          preview: URL.createObjectURL(file),
          formattedSize: formatFileSize2(file.size),
        })
        validatedFiles.push(validatedFile)
      } else {
        toast("Invalid file format! Only JPG, JPEG, PNG are allowed.")
      }
    })

    // Limit the number of selected files to 5
    setselectedFiles1(prevFiles => {
      const allFiles = [...prevFiles, ...validatedFiles]
      return allFiles.slice(0, 5)
    })
  }

  const formatFileSize2 = bytes => {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"]
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i]
  }


  const [Category, setCategory] = useState([])
  const [SubCategory, setSubCategory] = useState([])

  const [Facilities, setFacilities] = useState([])

  const Categoryss = selectedOptions => {
    setSelectedOptions(selectedOptions)
  }

  const options = Facilities.map(response => ({
    value: response._id,
    label: response.name,
  }))

  useEffect(() => {
    getCategory()
  }, [])

  const getCategory = () => {
    var token = datas
    axios
      .post(
        URLS.GetCategory,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setCategory(res.data.category)
      })
  }

  const Optionchange = e => {
    let myUser = { ...form }
    myUser[e.target.name] = e.target.value
    setform(myUser)
    getSubCategory(e.target.value)
  }

  const getSubCategory = data => {
    var token = datas
    const dataArray = {
      id: data,
    }
    axios
      .post(URLS.GetSubCategoryId, dataArray, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(res => {
        setSubCategory(res.data.subcategorys)
      })
  }

  const Optionchange1 = e => {
    let myUser = { ...form }
    myUser[e.target.name] = e.target.value
    setform(myUser)
    getFacilities(e.target.value)
  }

  const getFacilities = data => {
    var token = datas
    const dataArray = {
      id: data,
    }
    axios
      .post(URLS.GetFacilitiesId, dataArray, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(res => {
        setFacilities(res.data.facilities)
      })
  }

  useEffect(() => {
    GetOneActins()
  }, [])

  const Actinid = sessionStorage.getItem("ListingId")

  const GetOneActins = () => {
    const data = {
      id: Actinid,
    }

    var token = datas
    axios
      .post(URLS.GetByIdListing, data, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(res => {
        setform(res.data.data)
        setaddress(res.data.data.address)

        setTags(res.data.data.tag)

        const dataArray = {
          id: res.data.data.categoryId,
        }

        axios
          .post(URLS.GetSubCategoryId, dataArray, {
            headers: { Authorization: `Bearer ${token}` },
          })
          .then(res => {
            setSubCategory(res.data.subcategorys)
          })

        const dataArray1 = {
          id: res.data.data.subcategoryId,
        }

        axios
          .post(URLS.GetFacilitiesId, dataArray1, {
            headers: { Authorization: `Bearer ${token}` },
          })
          .then(res => {
            setFacilities(res.data.facilities)
          })

        setSelectedOptions(res.data.data.facilityDetails)

        const address = res.data.data

        setaddress(address.address)
        setState(address.state)
        setDistrict(address.city)
        setPincode(address.pincode)

        const c = { ...coordinateds }
        c["lat"] = address.longitude
        c["lng"] = address.latitude
        setcoordinateds(c)
      })
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Home" breadcrumbItem="Edit Listing" />
          <Form
            onSubmit={e => {
              handleSubmit(e)
            }}
          >
            <Row>
              <Col xl="12">
                <Button
                  onClick={history.goBack}
                  className="mb-3"
                  style={{ float: "right" }}
                  color="primary"
                >
                  <i className="far fa-arrow-alt-circle-left"></i>
                  Back
                </Button>
              </Col>
            </Row>
            <Card>
              <CardBody>
                <Row className="mt-2">
                  <Col lg="6">
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">
                        Business Name <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        id="basicpill-firstname-input1"
                        placeholder="Enter Business Name"
                        required
                        value={form.name}
                        name="name"
                        onChange={e => {
                          handlechange(e)
                        }}
                      />
                    </div>
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">
                        About Us (Business){" "}
                        {/* <span className="text-danger">*</span> */}
                      </Label>
                      <textarea
                        type="text"
                        rows="2"
                        className="form-control "
                        id="basicpill-firstname-input1"
                        placeholder="Optional"
                        // required
                        value={form.aboutUs}
                        name="aboutUs"
                        onChange={e => {
                          handlechange(e)
                        }}
                      />
                    </div>
                    <div className="mb-3">
                      <Label>Category</Label>
                      <span className="text-danger">*</span>
                      <select
                        value={form.categoryId}
                        name="categoryId"
                        required
                        onChange={e => {
                          Optionchange(e)
                        }}
                        className="form-select"
                      >
                        <option value="">Select</option>
                        {Category.map((data, key) => {
                          return (
                            <option key={key} value={data._id}>
                              {data.name}
                            </option>
                          )
                        })}
                      </select>
                    </div>
                    <div className="mb-3">
                      <Label>Sub Category</Label>
                      <span className="text-danger">*</span>
                      <select
                        value={form.subcategoryId}
                        name="subcategoryId"
                        required
                        onChange={e => {
                          Optionchange1(e)
                        }}
                        className="form-select"
                      >
                        <option value="">Select</option>
                        {SubCategory.map((data, key) => {
                          return (
                            <option key={key} value={data._id}>
                              {data.name}
                            </option>
                          )
                        })}
                      </select>
                    </div>
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">
                        Facilities
                        <span className="text-danger">*</span>
                      </Label>
                      <Select
                        options={options}
                        placeholder="Enter Facilities"
                        value={selectedOptions}
                        onChange={Categoryss}
                        isSearchable={true}
                        isMulti
                      />
                    </div>
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">
                        Tags
                        <span className="text-danger">*</span>
                      </Label>
                      <div className="tags-input-container">
                        {tags.map((tag, index) => (
                          <div className="tag-item" key={index}>
                            <span className="tag-text">{tag}</span>
                            <span
                              className="tag-close"
                              onClick={() => removeTag(index)}
                            >
                              &times;
                            </span>
                          </div>
                        ))}
                        <input
                          type="text"
                          value={inputValue}
                          onChange={handleInputChange}
                          onKeyDown={handleKeyDown}
                          placeholder="Enter Tags Type and press Enter"
                          id="twss"
                        />
                      </div>
                    </div>
                  </Col>
                  <Col lg="6">
                    <div
                      className="text-center m-4 mb-2"
                      style={{ paddingTop: "10px" }}
                    >
                      <h5>Business Logo</h5>

                      <div className="w-50 m-auto">
                        <Dropzone onDrop={handleDrop1}>
                          {({ getRootProps, getInputProps }) => (
                            <div className="dropzone">
                              <div
                                {...getRootProps()}
                                className="dz-message needsclick mt-2"
                              >
                                <input {...getInputProps()} />
                                <div className="mb-3">
                                  <i className="display-4 text-muted bx bxs-cloud-upload" />
                                </div>
                                <h4>Upload Image.</h4>
                              </div>
                            </div>
                          )}
                        </Dropzone>

                        <div
                          className="dropzone-previews mt-3"
                          id="file-previews"
                        >
                          {selectedFiles.map((f, i) => {
                            return (
                              <Card
                                className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                key={i + "-file"}
                              >
                                <div className="p-2">
                                  <Row className="align-items-center">
                                    <Col className="col-auto">
                                      <img
                                        data-dz-thumbnail=""
                                        height="40"
                                        className="avatar-sm rounded bg-light"
                                        alt={f.name}
                                        src={f.preview}
                                      />
                                    </Col>
                                    <Col>
                                      <Link
                                        to="#"
                                        className="text-muted font-weight-bold"
                                      >
                                        {f.name}
                                      </Link>
                                      <p className="mb-0">
                                        <strong>{f.formattedSize}</strong>
                                      </p>
                                    </Col>
                                  </Row>
                                </div>
                              </Card>
                            )
                          })}
                        </div>
                      </div>
                    </div>
                    <div
                      className="text-center m-4"
                      style={{ paddingTop: "10px" }}
                    >
                      <h5>Business Images</h5>
                      <div className="w-50 m-auto">
                        <Dropzone onDrop={handleDrop2}>
                          {({ getRootProps, getInputProps }) => (
                            <div className="dropzone">
                              <div
                                {...getRootProps()}
                                className="dz-message needsclick mt-2"
                              >
                                <input {...getInputProps()} />
                                <div className="mb-3">
                                  <i className="display-4 text-muted bx bxs-cloud-upload" />
                                </div>
                                <h4>Upload Image.</h4>
                              </div>
                            </div>
                          )}
                        </Dropzone>
                        <div
                          className="dropzone-previews mt-5"
                          id="file-previews"
                        >
                          {selectedFiles1.map((f, i) => {
                            return (
                              <Card
                                className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                key={i + "-file"}
                              >
                                <div className="p-2">
                                  <Row className="align-items-center">
                                    <Col className="col-auto">
                                      <img
                                        data-dz-thumbnail=""
                                        height="40"
                                        className="avatar-sm rounded bg-light"
                                        alt={f.name}
                                        src={f.preview}
                                      />
                                    </Col>
                                    <Col>
                                      <Link
                                        to="#"
                                        className="text-muted font-weight-bold"
                                      >
                                        {f.name}
                                      </Link>
                                      <p className="mb-0">
                                        <strong>{f.formattedSize}</strong>
                                      </p>
                                    </Col>
                                  </Row>
                                </div>
                              </Card>
                            )
                          })}
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row className="mt-4">
                  <Col md="4">
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">
                        Email
                        <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="email"
                        className="form-control"
                        id="basicpill-firstname-input1"
                        placeholder="Enter Email"
                        required
                        value={form.email}
                        name="email"
                        onChange={e => {
                          handlechange(e)
                        }}
                      />
                    </div>
                  </Col>
                  <Col md="4">
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">
                        Phone <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        id="basicpill-firstname-input1"
                        placeholder="Enter  Phone"
                        required
                        minLength="10"
                        maxLength="10"
                        pattern="[0-9]+"
                        value={form.contact}
                        name="contact"
                        onChange={e => {
                          handlechange(e)
                        }}
                      />
                    </div>
                  </Col>
                  <Col md="4">
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">
                        Website 
                        {/* <span className="text-danger">*</span> */}
                      </Label>
                      <textarea
                        type="text"
                        rows="1"
                        className="form-control "
                        id="basicpill-firstname-input1"
                        placeholder="Optional"
                        // required
                        value={form.website}
                        name="website"
                        onChange={e => {
                          handlechange(e)
                        }}
                      />
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">
                        Date of Establishment
                        <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="date"
                        className="form-control"
                        id="basicpill-firstname-input1"
                        placeholder="Enter Date Established"
                        required
                        value={form.dateEstablished}
                        name="dateEstablished"
                        onChange={e => {
                          handlechange(e)
                        }}
                      />
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">
                        Open Hours<span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="time"
                        className="form-control"
                        id="basicpill-firstname-input1"
                        placeholder="Enter Open Hours"
                        required
                        value={form.openTime}
                        name="openTime"
                        onChange={e => {
                          handlechange(e)
                        }}
                      />
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">
                        Close Hours
                        <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="time"
                        className="form-control"
                        id="basicpill-firstname-input1"
                        placeholder="Enter Close Hours"
                        required
                        value={form.closeTime}
                        name="closeTime"
                        onChange={e => {
                          handlechange(e)
                        }}
                      />
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input3">
                        Search location <span className="text-danger">*</span>
                      </Label>
                      <PlacesAutocomplete
                        value={address}
                        onChange={setaddress}
                        onSelect={handleSelects}
                      >
                        {({
                          getInputProps,
                          suggestions,
                          getSuggestionItemProps,
                          loading,
                        }) => (
                          <div
                            key={suggestions.description}
                            className="form-group "
                          >
                            <input
                              {...getInputProps({
                                placeholder: "Search location ...",
                                className: "location-search-input form-control",
                              })}
                            />
                            <div className="autocomplete-dropdown-container">
                              {loading && <div>Loading...</div>}
                              {suggestions.map(suggestion => {
                                const className = suggestion.active
                                  ? "suggestion-item--active"
                                  : "suggestion-item"
                                // inline style for demonstration purpose
                                const style = suggestion.active
                                  ? {
                                      backgroundColor: "#fafafa",
                                      cursor: "pointer",
                                    }
                                  : {
                                      backgroundColor: "#ffffff",
                                      cursor: "pointer",
                                    }

                                return (
                                  // <></>
                                  <div
                                    {...getSuggestionItemProps(suggestion, {
                                      className,
                                      style,
                                    })}
                                    key={suggestion.placeId}
                                  >
                                    <span>{suggestion.description}</span>
                                  </div>
                                )
                              })}
                            </div>
                          </div>
                        )}
                      </PlacesAutocomplete>
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="mb-3">
                      <label>Latitude</label>
                      <input
                        id="name"
                        type="number"
                        className="form-control"
                        placeholder="Enter latitude"
                        name="latittude"
                        value={coordinateds.lat}
                        disabled="disabled"
                        onChange={e => {
                          handlechange(e)
                        }}
                        required
                      />
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="mb-3">
                      <label>Longitude</label>
                      <input
                        id="name"
                        type="number"
                        className="form-control"
                        placeholder="Enter longitude"
                        name="longitude"
                        value={coordinateds.lng}
                        onChange={e => {
                          handlechange(e)
                        }}
                        disabled="disabled"
                        required
                      />
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">
                        State
                        <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        id="basicpill-firstname-input1"
                        placeholder="Enter State"
                        required
                        value={state}
                        name="state"
                        onChange={handleChange(setState)}
                      />
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">
                        District
                        <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        id="basicpill-firstname-input1"
                        placeholder="Enter District"
                        required
                        value={district}
                        name="district"
                        onChange={handleChange(setDistrict)}
                      />
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">
                        ZipCode
                        <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        id="basicpill-firstname-input1"
                        placeholder="Enter ZipCode"
                        required
                        value={pincode}
                        name="pincode"
                        onChange={handleChange(setPincode)}
                      />
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">
                        Address <span className="text-danger">*</span>
                      </Label>
                      <textarea
                        type="text"
                        rows="3"
                        className="form-control "
                        id="basicpill-firstname-input1"
                        placeholder="Enter Address"
                        required
                        value={address}
                        name="address"
                        onChange={handleChange(setaddress)}
                        // onChange={e => {
                        //   handlechange(e)
                        // }}
                      />
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody>
                    <h5
                      className="mb-4 text-primary"
                      style={{ color: "#806530", fontWeight: "bold" }}
                    >
                      Social Network
                    </h5>
                    <Row className="mt-3">
                      <Col md={4}>
                        <div className="mb-3">
                          <Label for="basicpill-firstname-input1">
                            FaceBook
                          </Label>
                          <Input
                            type="text"
                            className="form-control"
                            id="basicpill-firstname-input1"
                            placeholder="Enter FaceBook Links"
                            value={form.facebook}
                            name="facebook"
                            onChange={e => {
                              handlechange(e)
                            }}
                          />
                        </div>
                      </Col>
                      <Col md={4}>
                        <div className="mb-3">
                          <Label for="basicpill-firstname-input1">
                            Instragram
                          </Label>
                          <Input
                            type="text"
                            className="form-control"
                            id="basicpill-firstname-input1"
                            placeholder=" Instragram Link"
                            value={form.instagram}
                            name="instagram"
                            onChange={e => {
                              handlechange(e)
                            }}
                          />
                        </div>
                      </Col>
                      <Col md={4}>
                        <div className="mb-2">
                          <Label for="basicpill-firstname-input1">Google</Label>
                          <Input
                            type="text"
                            className="form-control"
                            id="basicpill-firstname-input1"
                            placeholder=" Google Link"
                            value={form.google}
                            name="google"
                            onChange={e => {
                              handlechange(e)
                            }}
                          />
                        </div>
                      </Col>
                      <Col md={4}>
                        <div className="mb-2">
                          <Label for="basicpill-firstname-input1">
                            Linkd In
                          </Label>
                          <Input
                            type="text"
                            className="form-control"
                            id="basicpill-firstname-input1"
                            placeholder="Enter LinkdIn Link"
                            value={form.linkedIn}
                            name="linkedIn"
                            onChange={e => {
                              handlechange(e)
                            }}
                          />
                        </div>
                      </Col>
                      <Col md={4}>
                        <div className="mb-2">
                          <Label for="basicpill-firstname-input1">
                            Youtube
                          </Label>
                          <Input
                            type="text"
                            className="form-control"
                            id="basicpill-firstname-input1"
                            placeholder="Youtube Link"
                            value={form.youtube}
                            name="youtube"
                            onChange={e => {
                              handlechange(e)
                            }}
                          />
                        </div>
                      </Col>
                      <Col md={4}>
                        <div className="mb-2">
                          <Label for="basicpill-firstname-input1">
                            Twitter
                          </Label>
                          <Input
                            type="text"
                            className="form-control"
                            id="basicpill-firstname-input1"
                            placeholder="Twitter"
                            value={form.twitter}
                            name="twitter"
                            onChange={e => {
                              handlechange(e)
                            }}
                          />
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
              <Col md={12}>
                <div className=" mb-2" style={{ float: "right" }}>
                  <button
                    type="submit"
                    style={{ width: "120px" }}
                    className="btn btn-info m-1"
                  >
                    Submit <i className="fas fa-check-circle"></i>
                  </button>
                </div>
              </Col>
            </Row>
          </Form>
          <ToastContainer />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default AddVendors
